module.exports = require("./../../_gen/starling/events/KeyboardEvent");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/KeyboardEvent.js
// module id = 182
// module chunks = 0